import React, {useState, useEffect } from "react";
import {connect} from "react-redux";
import {
  Modal
} from 'antd';
import _ from "i18n";
import {formatAmount, showErrorNotification} from "../../../services/utils";
import {
  createBankwire,
  getOrganizationMangoBalance
} from "../../../actions/thunks/mangoPay";
import ChoosePayinType from "./ChoosePayinType";
import EnterAmount from "./EnterAmount";
import FeedWithCard from "./FeedWithCard";
import FeedMangoModalFooter from "./FeedMangoModalFooter";
import EnterTag from "./EnterTag";
import BankwiresDatatable from "./BankwiresDatatable";
import { use } from "react";


const FeedMangoModal = ({
  orderId,
  isCreditNote,
  creditNoteId,
  isRefund,
  redirectionURL,
  amountToRefund,
  isModalVisible,
  handleModalVisibility,
  mangoPay,
  getOrganizationMangoBalance,
  createBankwire,
}) => {
  const [amount, setAmount] = useState(null);
  const [step, setStep] = useState(0);
  const [mangoBalance, setMangoBalance] = useState(null);
  const [payinType, setPayinTypeState] = useState(null); 
  const [tag, setTag] = useState(null);
  const [isCreatingBankwire, setIsCreatingBankwire] = useState(true);
  const [bankwireDetails, setBankwireDetails] = useState(null);

  useEffect(() => {
    if(amountToRefund != null){
      calculateAmount(amountToRefund, mangoBalance);
    }
  },[]);

  const onCancelModal = () =>{
    setStep(0);
    setAmount(null);
    setTag(null);
    setPayinTypeState(null);
    handleModalVisibility(false);
  }

  const handleAmountInputChange = (v) => {
    if(isNaN(v))
      return;
    setAmount(v);
  }

  const changeStep = (v) => {
    setStep(v);
  }

  const setPayinType = (payinType) => {
    setPayinType(payinType);
    setStep(1);
  };

  const handleTagInputChange = (v) => {
    if(v.length < 255){
      setTag(v);
    }
  }

  const renderStep2 = () => {
    if(payinType === "CARD"){
      return (
        <FeedWithCard orderId={orderId}
                      creditNote={isCreditNote}
                      creditNoteId={creditNoteId}
                      refund={isRefund}
                      redirectionURL={redirectionURL}
                      amount={amount}
                      mangoPay={mangoPay}/>
      );
    } else {
      return (
        <EnterTag value={tag} onChange={({target: {value}}) => handleTagInputChange(value)}/>
      );
    }
  }

  const showBankwires = () => {
    setStep(-1);
  }

  const calculateAmount = (amountToRefund, mangoBalance) =>{
    let amount = (amountToRefund - mangoBalance) / 100;
    if(Math.round(amount) > amount){
      setAmount(Math.round(amount));
    } else {
      setAmount(Math.round(amount) + 1);
    }
  }
    return (
      <Modal
        visible={isModalVisible}
        width={'730px'}
        wrapClassName={'feed-mango-wallet'}
        centered
        title={_("FEED_MANGO_WALLET")}
        maskClosable={false}
        onCancel={onCancelModal}
        footer={(step !== 0 && step !==3) ?
          <FeedMangoModalFooter amount={amount} step={step} changeStep={changeStep} payinType={payinType} tag={tag}/>
          : null
        }
      >
        {
          step === 0 && <ChoosePayinType setPayinType={setPayinType} showBankwires={showBankwires}/>
        }

        {
          step === 1 &&
          <EnterAmount amount={mangoBalance}
                       value={amount}
                       onChange={({target: {value}}) => handleAmountInputChange(value)}/>
        }

        {
          step === 2 && renderStep2()
        }

        {
          step === -1 && <BankwiresDatatable/>
        }

      </Modal>
    );

}

const mapStateToProps = state => ({
  currentClient: state.auth.currentClient,
  mangoPay: state.mangoPay,
});

const mapDispatchToProps = {
  getOrganizationMangoBalance,
  createBankwire,
};

export default connect(mapStateToProps, mapDispatchToProps)(FeedMangoModal);



// WEBPACK FOOTER //
// ./app/components/Admin/FeedMangoWallet/FeedMangoModal.js